import { PAGE_ROUTES } from '@/components/nav/utils/url-builders';
import { isPageActive } from '@/lib/is-page-active';
import {
  confirmationHistoryStore,
  confirmationsStore,
  dealStore,
  primaryCustomerStore,
  smsAgentMessageStore,
  userStore,
  vehicleFromIndexerStore,
  vehicleListingStore,
} from '@/models/stores';
import { runInAction } from 'mobx';
import { useEffect } from 'react';

const useDealsPageHydrateLocal = () => {
  const isDealsPageActive = isPageActive(PAGE_ROUTES.DEALS);
  const shouldRun = isDealsPageActive;

  useEffect(() => {
    if (!shouldRun) {
      return;
    }

    const hydrateDeals = async () => {
      // Dev note: This can be optimized by running this for only the deals above the fold
      // and for just my deals
      await Promise.all([
        dealStore.hydrateActiveDeals(),
        primaryCustomerStore.hydrateLocal(),
        vehicleFromIndexerStore.hydrateLocal(),
        vehicleListingStore.hydrateLocal(),
        userStore.hydrateLocal(),
        smsAgentMessageStore.hydrateLocal(),
      ]);

      await Promise.all([
        confirmationsStore.hydrateOnlyForNewDeals(),
        confirmationHistoryStore.hydrateOnlyForNewDeals(),
      ]);
    };

    runInAction(async () => {
      await hydrateDeals();
    });
  }, [shouldRun]);
};

export default useDealsPageHydrateLocal;
